import apiCompetition from '@/api/competition'
import {isEmpty, isNil, pipe, propOr, reject, unless} from 'ramda'

const state = {
  data: [],
  isLoading: false,
  error: null,
  total: 1,
  lastPage: null,
}

export const mutationTypes = {
  getCompetitionsCalendarStart: '[competition calendar] Get competitions start',
  getCompetitionsCalendarSuccess:
    '[competition calendar] Get competitions success',
  getCompetitionsCalendarFailure:
    '[competition calendar] Get competitions failure',
}

export const actionTypes = {
  getCompetitionsCalendar: '[competition calendar] Get competition',
}

const mutations = {
  [mutationTypes.getCompetitionsCalendarStart](state) {
    state.isLoading = true
    state.error = null
  },

  [mutationTypes.getCompetitionsCalendarSuccess](state, payload) {
    state.data = payload
    state.total = payload.total
    state.lastPage = payload.lastPage
    state.isLoading = false
  },

  [mutationTypes.getCompetitionsCalendarFailure](state, payload) {
    state.isLoading = false
    state.error = payload
  },
}

const actions = {
  [actionTypes.getCompetitionsCalendar](context, data) {
    const params = pipe(
      propOr(null, 'params'),
      unless(isNil, reject(isEmpty))
    )(data)

    context.commit(mutationTypes.getCompetitionsCalendarStart)
    return new Promise((resolve) => {
      apiCompetition
        .getCompetitionsForCalendar(params)
        .then((response) => {
          context.commit(
            mutationTypes.getCompetitionsCalendarSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch((error) => {
          context.commit(mutationTypes.getCompetitionsCalendarFailure, error)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
